// import API from "@/js/API"
// import { post } from "@/js/lib/api"
import isEmpty from "lodash/isEmpty"
import googleAnalysis from "@/js/lib/ga";
import { klaviyo_addtocart } from "@/js/methods";

export default {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {
    /**
     * 添加到购物车
     * @param {*} _ 
     * @param { payload } param1 
     * payload需要两个参数 data: 正常post的参数， productDetail 是需要记录事件的参数
     */
    async addToCart(_, { payload }) {
      const { productDetail = {} } = payload
      const requestData = payload.data

      const res = await window.axios.post(API.addcart, requestData)

      const { status } = res
      const responseData = res.data

      // 执行成功后，处理一些事务
      if (status === 200) {
        // 记录到fb事件
        if (window.fbq && !isEmpty(productDetail)) {
          // 变种详情
          const variantsDetail = productDetail?.variants_detail || [];

          const fbData = {
            content_type: "product_group",
            num_items: 1,
            content_name: productDetail.title,
            currency: responseData.currency,
            content_category: productDetail?.categories || [],
          }
          if (variantsDetail.length > 0) {
            fbData.content_ids = [variantsDetail?.[0]?.ID]
            fbData.value = variantsDetail?.[0]?.price
          } else {
            fbData.content_ids = [productDetail.ID]
            fbData.value = productDetail.price
          }

          window.send_fb_event("AddToCart", fbData);
        }

        // 记录事件
        if (window._learnq) {
          klaviyo_addtocart(this.productDetail, data);
        }

        // 记录snapchat事件
        if (window.snaptr) {
          window.snaptr('track', 'ADD_CART', {
            'currency': responseData.currency,
            'item_category': null,
            'item_ids': [productDetail.ID],
            'number_items': 1,
            'price': productDetail.price,
          })
        }

        // 记录到谷歌分析
        googleAnalysis.event(googleAnalysis.gaAction.add);
      }

      return res
    }
  }
}